import * as ReactRedux from 'react-redux';
import { AppState } from '../app/app.types';
import BusinessInfoComponent from './BusinessInfoComponent';
import { CreateUpdateRequestParameters } from '../business/business.types';
import  {
  registerOrUpdateBusiness,
  validateBusinessPhoneNumber,
  getStatements
} from '../business/business.actions';
import { push } from 'react-router-redux';
import { paths } from '../app/app.routes';

const mapDispatchToProps = (dispatch: Function) => {
  return {
    updateBusiness: (requestParam: CreateUpdateRequestParameters) =>
      dispatch(registerOrUpdateBusiness(requestParam, false)),
    validateBusinessPhoneNumber: (email: string) => dispatch(validateBusinessPhoneNumber(email)),
    toAdminDashboard: () => dispatch(push(paths.adminDashboard)),
    getStatements: () => dispatch(getStatements())
  };
};

const mapStateToProps = (state: AppState) => {
  return {
    authState: state.authState,
    adminState: state.adminState,
    businessState: state.businessState
  };
};

const BusinessInfo = ReactRedux.connect(mapStateToProps, mapDispatchToProps)(BusinessInfoComponent);

export default BusinessInfo;


// WEBPACK FOOTER //
// ./src/account/BusinessInfo.tsx